import { Controller } from '@hotwired/stimulus'

export default class DobController extends Controller {
  static targets = ['day', 'month', 'year']

  connect() {
    this.updateDays()
  }

  updateDays() {
    const year = parseInt(this.yearTarget.value, 10)
    const month = parseInt(this.monthTarget.value, 10)

    const today = new Date()
    const currentYear = today.getFullYear()
    const currentMonth = today.getMonth() + 1
    const currentDay = today.getDate()

    // Enable all month options
    Array.from(this.monthTarget.options).forEach((option) => {
      option.disabled = false
    })

    // Disable future months for current year
    if (year === currentYear) {
      Array.from(this.monthTarget.options).forEach((option) => {
        const value = parseInt(option.value, 10)
        if (!isNaN(value) && value > currentMonth) {
          option.disabled = true
        }
      })

      if (month > currentMonth) {
        this.monthTarget.value = ""
        this.dayTarget.value = ""
        return
      }
    }

    if (!year || !month) {
      this.dayTarget.value = ""
      return
    }

    const maxDays = new Date(year, month, 0).getDate()

    // Enable/disable day options
    Array.from(this.dayTarget.options).forEach((option) => {
      const value = parseInt(option.value, 10)
      if (isNaN(value)) return // Skip prompt option if present

      option.disabled = false
      if (value > maxDays) {
        option.disabled = true
      }

      if (
        year === currentYear &&
        month === currentMonth &&
        value > currentDay
      ) {
        option.disabled = true
      }
    })

    const selectedDay = parseInt(this.dayTarget.value, 10)
    if (
      selectedDay > maxDays ||
      (year === currentYear &&
        month === currentMonth &&
        selectedDay > currentDay)
    ) {
      this.dayTarget.value = ""
    }
  }
}
